import { Box, BoxProps } from '@chakra-ui/react';

export function MainWrapper(props: BoxProps): JSX.Element {
  return (
    <Box
      as="main"
      w="100%"
      boxSizing="border-box"
      px={{ base: 'space_unit.x2', md: 'space_unit.x2', lg: 'space_unit.x4' }}
      py={{ base: 'space_unit.x2', md: 'space_unit.x4' }}
      {...props}
    />
  );
}
